<template>
    <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
      <div class="bg-white rounded-lg shadow-2xl m-4 md:m-0 p-6 max-w-lg w-full max-h-[90dvh] overflow-y-auto">
        <!-- Greeting and Login Form -->
        <h1 class="text-2xl md:text-3xl font-bold mb-4">Welcome to Geo Racers!</h1>
        <p class="text-gray-700 mb-6">You're about to play the most fun and strategic game this side of the Mississippi!</p>
        <!-- Separator -->
        <div class="relative mt-8">
          <GuestRegister @success="user => $emit('logged-in', user)" />
        </div>
      </div>
    </div>
  </template>

<script setup>
import { ref } from 'vue';
import Login from '@/Login.vue';
import Register from '@/Register.vue';
import GuestRegister from '@/GuestRegister.vue';

const isExistingUser = ref(true);

// Emit a "play-as-guest" event when the user clicks the button.
const emit = defineEmits(['logged-in', 'registered', 'play-as-guest']);
</script>

